module.exports = __webpack_public_path__ + "static/media/01_MICS-1.2-S-8.6cb5e888.svg";